export const CREATE_LIGHTBOX = 'Create ligthbox'
